module.exports = __webpack_public_path__ + "img/web2.0f876f7b.png";